import React from 'react';

export default function HelpIcon(): JSX.Element {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.23026 0.00328898C2.28824 0.00328898 0 2.37325 0 5.23355V31.3849C0 34.3269 2.28824 36.6151 5.23026 36.6151H31.3816C34.2419 36.6151 36.6118 34.3269 36.6118 31.3849V5.23355C36.6118 2.37325 34.2419 0.00328898 31.3816 0.00328898H5.23026ZM11.196 10.9542C11.8498 9.07453 13.566 7.84868 15.5273 7.84868H20.2673C23.1276 7.84868 25.4975 10.2186 25.4975 13.0789C25.4975 14.8769 24.4351 16.593 22.8824 17.492L20.2673 19.0447C20.1855 20.1071 19.3683 20.9243 18.3059 20.9243C17.1618 20.9243 16.3446 20.1071 16.3446 18.963V17.9006C16.3446 17.1651 16.6715 16.5113 17.3252 16.1844L20.9211 14.1413C21.3297 13.8962 21.5748 13.4876 21.5748 13.0789C21.5748 12.3434 21.0028 11.8531 20.2673 11.8531H15.5273C15.2822 11.8531 15.037 12.0165 14.9553 12.2617L14.8736 12.3434C14.5467 13.4058 13.4025 13.8962 12.4219 13.5693C11.3595 13.1607 10.8691 12.0165 11.196 11.0359V10.9542ZM20.9211 26.1546C20.9211 27.6256 19.6952 28.7697 18.3059 28.7697C16.8349 28.7697 15.6908 27.6256 15.6908 26.1546C15.6908 24.7653 16.8349 23.5395 18.3059 23.5395C19.6952 23.5395 20.9211 24.7653 20.9211 26.1546Z"
        fill="black"
      />
    </svg>
  );
}
